module.exports = __webpack_public_path__ + "img/new-hide-hose.574b5802.png";